export default __webpack_public_path__ + "static/media/learn-more-card-7.ed385a6a.svg";